import React from 'react';
import { MenuProps } from 'antd';
import { Trans } from 'react-i18next';
import { ColumnsType } from 'common/components/antd/Table/Table';
import TableActionColumnDropdown from 'common/components/TableActionColumnDropdown/TableActionColumnDropdown';
import { alphabeticSortFn } from 'common/utils/sort.utils';
import { ECounterpartyColumnKeys } from 'domains/counterparties/constants';
import { TCounterpartyTableRecord } from '../types/counterparties.types';

export const getColumns = ({
  menuItems,
  onItemActionClick,
}: {
  menuItems?: MenuProps['items'];
  onItemActionClick?: any;
} = {}): ColumnsType<TCounterpartyTableRecord> => [
  {
    title: <Trans i18nKey="usrRoleMng.counterparties.table.column.logo" />,
    key: ECounterpartyColumnKeys.LogoUrl,
    dataIndex: ECounterpartyColumnKeys.LogoUrl,
    render: (value) => value ? <img src={value} height='60' width='auto' alt='' /> : '',
  },
  {
    title: <Trans i18nKey="usrRoleMng.counterparties.table.column.name" />,
    width: 290,
    key: ECounterpartyColumnKeys.Name,
    dataIndex: ECounterpartyColumnKeys.Name,
    searchable: true,
    sorter: alphabeticSortFn(ECounterpartyColumnKeys.Name),
  },
  {
    title: <Trans i18nKey="usrRoleMng.counterparties.table.column.code" />,
    width: 290,
    key: ECounterpartyColumnKeys.Code,
    dataIndex: ECounterpartyColumnKeys.Code,
    searchable: true,
  },
  {
    title: <Trans i18nKey="usrRoleMng.counterparties.table.column.holdingShortName" />,
    width: 290,
    key: ECounterpartyColumnKeys.HoldingName,
    dataIndex: ECounterpartyColumnKeys.HoldingName,
    searchable: true,
  },
  {
    title: <Trans i18nKey="usrRoleMng.counterparties.table.column.description" />,
    width: 474,
    key: ECounterpartyColumnKeys.Description,
    dataIndex: ECounterpartyColumnKeys.Description,
  },
  {
    width: 32,
    key: 'rowNavigation',
    render: (status: number, record) => (
      <TableActionColumnDropdown
        record={record}
        onClickItemAction={onItemActionClick}
        menuItems={menuItems}
      />
    ),
  },
];
